import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const homeGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.currentUser();
  
  if (user) {
    // Usuário logado, redirecionar para dashboard apropriado
    if (user.tipo === 'farmacia') {
      router.navigate(['/farmacia/dashboard'], { replaceUrl: true });
    } else if (user.tipo === 'clinica') {
      router.navigate(['/clinica/dashboard'], { replaceUrl: true });
    } else if (user.tipo === 'admin') {
      router.navigate(['/admin/dashboard'], { replaceUrl: true });
    } else {
      router.navigate(['/paciente/dashboard'], { replaceUrl: true });
    }
    return false;
  }

  // Não logado, pode acessar home
  return true;
};
